import {connect} from 'react-redux';
import {getTranslation} from "../../../reducers/common/localization";
import {
    getContinentsData,
    getCountriesData,
    getCurrentContinent,
    setCurrentContinent,
} from "../../../reducers/common/location";
import {resetSubmitFormData} from "../../../reducers/common/submitForm";
import OrgSettings from "./OrgSettings";
import {
    fetchEditOrgByAnchor, fetchGetOrg, getOrgSettings, loadingOrg
} from "../../../reducers/organization/organization";

const mapStateToProps = state => {
    return {
        data: getOrgSettings(state),
        loading: loadingOrg(state),
        translation: getTranslation(state),
        continentCode: getCurrentContinent(state),
        continents: getContinentsData(state),
        countries: getCountriesData(state),
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onMount: () => dispatch(fetchGetOrg()),
        onSetContinent: (continentCode) => {
            dispatch(setCurrentContinent(continentCode));
        },
        onUnmount: () => {
            dispatch(resetSubmitFormData());
            dispatch(setCurrentContinent(''));
        },
        onSaveChanges: data => dispatch(fetchEditOrgByAnchor(data))
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(OrgSettings);



// WEBPACK FOOTER //
// ./src/components/organizationManagement/orgSettings/OrgSettings.container.js